import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '../views/Index'
import About from '../views/About'
import News from '../views/News'
import Mien from '../views/Mien'
import Contact from '../views/Contact'
import Guild from '../views/Guild'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      children:[
        {
          path: '/about',
          name: 'About',
          component: About,
        },
        {
          path: '/mien',
          name: 'Mien',
          component: Mien,
        },
        {
          path: '/news',
          name: 'News',
          component: News,
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact,
        },
        {
          path: '/guild',
          name: 'Guild',
          component: Guild,
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js